import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { isPlatformServer } from '@angular/common';
import { webSiteschemaService } from 'src/app/modules/shared/_services/website-schema.service';

@Injectable({
    providedIn: 'root'
})
export class MetaService {
    private baseUrl: string = environment.TENDER.BASE_URL;
    isServer: any;
    constructor(
        private meta: Meta,
        private title: Title,
        private router: Router,
        @Inject(PLATFORM_ID) platformId: any,
        @Inject(DOCUMENT) private document: Document,private webSiteschema: webSiteschemaService
    ) {
        this.isServer = isPlatformServer(platformId);
    }

    setMetaTags(title: string, description: string): void {
        this.title.setTitle(title);
        const imageUrl = 'https://d1tiqtcifmy0l7.cloudfront.net/prod/images/logo/Tender_Shark_logo.webp';
        this.meta.addTags([
            { name: 'robots', content: 'index,follow' },
            { name: 'description', content: description },
            { name: 'og:description', content: description },
            { name: 'og:title', content: title },
            { name: 'og:site_name', content: 'TenderShark' },
            { name: 'og:type', content: 'website' },
            { name: 'og:url', content: this.getFullUrl() },
            { name: 'og:image', content: imageUrl },
            { name: 'twitter:card', content: 'summary' },
            { name: 'twitter:site', content: '@tender_shark' },
            { name: 'twitter:title', content: title },
            { name: 'twitter:description', content: description },
            { name: 'twitter:image', content: imageUrl }
        ]);

        if (this.isServer) {
            this.addCanonicalLink();
            this.webSiteschema.setWebSiteSchema();
        }
    }

    private getFullUrl(): string {
        return `${this.baseUrl}${this.router.url.split('?')[0].toLowerCase()}`;
    }

    private addCanonicalLink(): void {
        const link = this.document.createElement('link');
        link.rel = 'canonical';
        link.href = this.getFullUrl();
        this.document.head.appendChild(link);
    }
}